import React, { useState } from "react"

import { makeStyles } from "@material-ui/core/styles"
import Box from "@material-ui/core/Box"
import Collapse from "@material-ui/core/Collapse"
import IconButton from "@material-ui/core/IconButton"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TableRow from "@material-ui/core/TableRow"
import Typography from "@material-ui/core/Typography"
import Paper from "@material-ui/core/Paper"
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown"
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp"
import List from "@material-ui/core/List"
import ListItem from "@material-ui/core/ListItem"
import CssBaseline from "@material-ui/core/CssBaseline"
import ListItemIcon from "@material-ui/core/ListItemIcon"
import ListItemText from "@material-ui/core/ListItemText"
import Divider from "@material-ui/core/Divider"

const HiddenDrsInfo = ({ info }) => {
  const {
    ocupacao_de_leitos,
    total_de_leitos,
    internacoes,
    casos,
    obitos,
    fase,
  } = info

  const itemColorCasos = faseItem => {
    let color = "black"

    if (faseItem === 1) {
      color = "red"
    } else if (faseItem === 2) {
      color = "red"
    } else if (faseItem === 3) {
      color = "red"
    } else if (faseItem === 4) {
      color = "green"
    } else if (faseItem === 5) {
      color = "green"
    }

    return color
  }

  const itemColorObitos = faseItem => {
    let color = "black"

    if (faseItem === 1) {
      color = "red"
    } else if (faseItem === 2) {
      color = "red"
    } else if (faseItem === 3) {
      color = "green"
    } else if (faseItem === 4) {
      color = "green"
    } else if (faseItem === 5) {
      color = "green"
    }

    return color
  }

  const leitos_por_100k =
    total_de_leitos["leitos_por_100k"] !== "NaN"
      ? Math.round(total_de_leitos["leitos_por_100k"] * 10) / 10
      : "-"

  const ocupacao_uti =
    ocupacao_de_leitos["ocupacao_leitos_uti"] !== "NaN"
      ? `${Math.round(ocupacao_de_leitos["ocupacao_leitos_uti"] * 10) / 10}%`
      : "-"

  const { casos_semana, casos_semana_anterior } = casos

  const var_casos =
    casos["var"] !== "NaN"
      ? `${Math.round((casos["var"] - 1) * 10000) / 100}%`
      : "-"

  const colorCasos = itemColorCasos(casos["indicador"])

  const { obitos_semana, obitos_semana_anterior } = obitos

  const var_obitos =
    obitos["var"] !== "NaN"
      ? `${Math.round((obitos["var"] - 1) * 10000) / 100}%`
      : "-"

  const colorObitos = itemColorObitos(obitos["indicador"])

  const internacoes_antes = internacoes["antes"]
  const internacoes_depois = internacoes["depois"]

  const var_internacoes =
    internacoes["var"] !== "NaN"
      ? `${Math.round((internacoes["var"] - 1) * 10000) / 100}%`
      : "-"

  const colorInternacoes = itemColorObitos(internacoes["indicador"])

  const total_leitos =
  total_de_leitos["total_leitos_uti"] !== "NaN"
      ? `${Math.round(total_de_leitos["total_leitos_uti"])}`
      : "-"

  return (
    <div>
      <List
        style={{ padding: 0, alignItems: "center", justifyContent: "center" }}
      >
        <ListItem style={{ padding: "10px 0", display: "inline-block" }}>
          <Typography variant="button">Casos na semana:</Typography>
          <Typography variant="h6" style={{ color: "black" }}>
            {" "}
            {casos_semana}
          </Typography>
          <Typography variant="button">Casos na semana anterior:</Typography>
          <Typography variant="h6" style={{ color: "black" }}>
            {casos_semana_anterior}
          </Typography>
          <Typography variant="button">Variação de casos:</Typography>
          <Typography variant="h6" style={{ color: colorCasos }}>
            {var_casos}
          </Typography>
        </ListItem>
        <Divider />
        <ListItem style={{ padding: "10px 0", display: "inline-block" }}>
          <Typography variant="button">Óbitos na semana:</Typography>
          <Typography variant="h6" style={{ color: "black" }}>
            {" "}
            {obitos_semana}
          </Typography>
          <Typography variant="button">Óbitos na semana anterior:</Typography>
          <Typography variant="h6" style={{ color: "black" }}>
            {" "}
            {obitos_semana_anterior}
          </Typography>
          <Typography variant="button">Variação de óbitos:</Typography>
          <Typography variant="h6" style={{ color: colorObitos }}>
            {" "}
            {var_obitos}
          </Typography>
        </ListItem>
        <Divider />
        <ListItem style={{ padding: "10px 0", display: "inline-block" }}>
          <Typography variant="button">Internações na semana:</Typography>
          <Typography variant="h6" style={{ color: "black" }}>
            {" "}
            {internacoes_depois}
          </Typography>
          <Typography variant="button">
            Internações na semana anterior:
          </Typography>
          <Typography variant="h6" style={{ color: "black" }}>
            {" "}
            {internacoes_antes}
          </Typography>
          <Typography variant="button">Variação de internações:</Typography>
          <Typography variant="h6" style={{ color: colorInternacoes }}>
            {" "}
            {var_internacoes}
          </Typography>
        </ListItem>
        <Divider />
        <ListItem style={{ padding: "10px 0", display: "inline-block" }}>
          <Typography variant="button">
            Total de leitos de UTI:
          </Typography>
          <Typography variant="h6" style={{ color: "black" }}>
            {total_leitos}
          </Typography>
          <Typography variant="button">
            Leitos de UTI/100 mil pessoas:
          </Typography>
          <Typography variant="h6" style={{ color: "black" }}>
            {leitos_por_100k}
          </Typography>
          <Typography variant="button">
            Média de ocupação de UTIs (*):
          </Typography>
          <Typography variant="h6" style={{ color: "black" }}>
            {ocupacao_uti}
          </Typography>
        </ListItem>
      </List>
    </div>
  )
}

const DRSRow = ({ drs, drsInfo }) => {
  const [open, setOpen] = React.useState(false)
  const rowInfo = drsInfo[drs]

  const {
    total_de_leitos,
    ocupacao_de_leitos,
    internacoes,
    obitos,
    casos,
    fase,
  } = rowInfo

  const fase_final = fase["fase_final"]

  const itemColor = () => {
    let color = "white"

    if (fase_final === 1) {
      color = "red"
    } else if (fase_final === 2) {
      color = "orange"
    } else if (fase_final === 3) {
      color = "yellow"
    } else if (fase_final === 4) {
      color = "green"
    } else if (fase_final === 5) {
      color = "blue"
    }

    return color
  }

  return (
    <div>
      <ListItem
        button
        style={{ backgroundColor: itemColor() }}
        onClick={() => setOpen(!open)}
      >
        <IconButton size="small" style={{ outline: "none" }}>
          {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </IconButton>
        <Box mr="auto" align="left">
          <ListItemText>{drs}</ListItemText>
        </Box>
        <Box pl={3} align="right">
          <ListItemText>{fase_final}</ListItemText>
        </Box>
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItem button>
            <ListItemIcon>
              <HiddenDrsInfo info={rowInfo} />
            </ListItemIcon>
          </ListItem>
        </List>
      </Collapse>
    </div>
  )
}

function DRSTable({ infoData, date }) {
  const drsList = [
    "Estado de São Paulo",
    "Município de São Paulo",
    "Grande SP Leste",
    "Grande SP Norte",
    "Grande SP Oeste",
    "Grande SP Sudeste",
    "Grande SP Sudoeste",
    "DRS 02 Araçatuba",
    "DRS 03 Araraquara",
    "DRS 04 Baixada Santista",
    "DRS 05 Barretos",
    "DRS 06 Bauru",
    "DRS 07 Campinas",
    "DRS 08 Franca",
    "DRS 09 Marília",
    "DRS 10 Piracicaba",
    "DRS 11 Presidente Prudente",
    "DRS 12 Registro",
    "DRS 13 Ribeirão Preto",
    "DRS 14 São João da Boa Vista",
    "DRS 15 São José do Rio Preto",
    "DRS 16 Sorocaba",
    "DRS 17 Taubaté",
  ]

  const drsInfo = infoData[date]

  return (
    <div style={{ padding: "0", margin: "20px auto" }}>
      <Box className="center" style={{ padding: "0", margin: "0 auto" }}>
        <Paper style={{ padding: "0", margin: "0", maxWidth: "90%" }}>
          <List style={{ padding: "0" }}>
            <ListItem>
              <IconButton size="small" />
              <Box mr="auto" align="left">
                <ListItemText>
                  <strong>Região</strong>
                </ListItemText>
              </Box>
              <Box pl={3} align="right">
                <ListItemText>
                  <strong>Fase</strong>
                </ListItemText>
              </Box>
            </ListItem>
            {drsList.map(drs => (
              <DRSRow key={drs} drs={drs} drsInfo={drsInfo} />
            ))}
          </List>
        </Paper>
      </Box>
    </div>
  )
}

export default DRSTable
